<template>
  <v-card flat :color="attrCardColor" class="">
    <v-card-text :class="attrCardClass">
      <v-text-field
      :class="readOnlyTextFieldClass"
      dense
      readonly
      :label="label"
      :value="value">
        <template #prepend-inner>
          <slot name="prepend-inner"/>
        </template>

        <template #prepend>
          <slot name="prepend"/>
        </template>

        <template #append>
          <slot name="append"/>
        </template>

        <template #append-outer>
          <slot name="append-outer"/>
        </template>
      </v-text-field>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'ReadOnlyAttributeCard',

  props: {
    label: {
      type: String,
      required: true
    },

    value: {
      type: String,
      required: true
    }
  },

  data: () => ({
    attrCardColor: 'grey lighten-4',
    attrCardClass: 'prevent-select',
    readOnlyTextFieldClass: 'prevent-select mb-n4'
  })
}
</script>

<style>
.read-only-attr-container .prevent-select .v-text-field__slot,
.read-only-attr-container .prevent-select .v-text-field__slot * {
  pointer-events: none;
  user-select: none;
}
</style>
